import React, { useEffect, useState } from "react";
import { usePagination } from "../../../../../hooks/usePagination/usePagination";
import ScrollTable from "./scroll-table";

const ExceptionsInfo = ({
  data,
  dataLength,
  page,
  loading,
  dispatchPagination,
}) => {
  return (
    <ScrollTable
      data={data}
      dataLength={dataLength}
      page={page}
      dispatchPagination={dispatchPagination}
      loading={loading}
    />
  );
};

export default ExceptionsInfo;
